// Route prefix for the standalone full-viewport contract template editor.
// Used by Topbar and AdminFooter to hide chrome on this route.
export const STANDALONE_EDITOR_PREFIX = '/contractTemplateEditor';

// Settings area renders as a separate admin mode: no navbar/tab strip/footer,
// the sidebar carries navigation, back-to-app and the user menu.
export const SETTINGS_PREFIX = '/AdminScreen/Config';

export const ADMIN_NAV_SECTIONS = [
	{
		schema: 'dashboard',
		label: 'Inicio'
	},
	{
		schema: 'accounts',
		label: 'Cuentas'
	},
	{
		schema: 'debts',
		label: 'Deudas'
	},
	{
		schema: 'credits',
		label: 'Pasividades'
	},
	{
		schema: 'contracts',
		label: 'Alquileres'
	},
	{
		schema: 'assets',
		label: 'Activos fijos'
	},
	{
		schema: 'assetSales',
		label: 'Ventas'
	},
	{
		schema: 'reports',
		label: 'Reportes'
	},
	{
		schema: 'predictions',
		label: 'Previsiones'
	},
];
